export default "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"mdi-lightning-bolt\" viewBox=\"0 0 24 24\"><path d=\"M11 15H6L13 1V9H18L11 23V15Z\" /></svg>"